module.exports = __webpack_public_path__ + "img/15.7d7b57d6.jpg";